export default __webpack_public_path__ + "static/media/faq_1_img_2.5fc307ba.svg";